import React from 'react'
import { useNavigate } from 'react-router-dom'
import he from 'he'

const SmallImageCard = ({card,heading,index,mobile,title,hydrating}) => {
         
          const navigate=useNavigate()

      const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);

  const  goTO = (url) =>  {
     
      navigate(url)
      
  }


  return (
   
    <div  className={`small-image-card ${hydrating ? 'ssr-hidden' : ''}`} >
          <img loading={((heading === 'Shhh Gup Chip') || (!mobile && heading === 'Happy Happyga')) ? 'auto' : 'lazy'}
           src={card.stimg ? card.stimg : '/comedy/assets/images/error_img.webp'} 
           onClick={() => goTO(card.url_link ?  card.url_link.substring(card.url_link.indexOf('comedy')+6).replace("?","-") : '/') } alt="small-img"  />
    <div className='content' onClick={() => goTO(card.url_link ?  card.url_link.substring(card.url_link.indexOf('comedy')+6).replace("?","-") : '/') }>
         <h5  className={card.title && isTelugu(card.title) ? 'small-card-tl' : 'small-card-en'} >{card[title] ? card[title] : ' '}</h5>
    </div>
     </div>
  )
}

export default SmallImageCard;
